import { render, staticRenderFns } from "./GotWrongBook.vue?vue&type=template&id=fd8fd048&scoped=true"
import script from "./GotWrongBook.vue?vue&type=script&lang=js"
export * from "./GotWrongBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8fd048",
  null
  
)

export default component.exports